module.exports = __webpack_public_path__ + "img/site-belenes.7797789b.jpg";